import { CircleCheckTransparent } from '@/components/Icons/CircleCheckTransparent';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function BannerBottom() {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				display: {
					xs: 'none',
					md: 'flex'
				},
				width: '100%',
				minHeight: '48px',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '8px',
				borderTop: '1px solid',
				borderColor: 'divider',
				borderBottomLeftRadius: '12px',
				borderBottomRightRadius: '12px',
				bgcolor: 'neutral.150',
				color: 'primary.main'
			}}
		>
			<CircleCheckTransparent />

			<Typography variant="body1" fontWeight={500}>
				{t('fastCheckout.bannerBottom')}
			</Typography>
		</Box>
	);
}

export default BannerBottom;
